// FontWeights -> https://drafts.csswg.org/css-fonts/#font-weight-numeric-values
var FontWeights;
(function (FontWeights) {
    FontWeights[FontWeights["Thin"] = 100] = "Thin";
    FontWeights[FontWeights["ExtraLight"] = 200] = "ExtraLight";
    FontWeights[FontWeights["Light"] = 300] = "Light";
    FontWeights["Regular"] = "normal";
    FontWeights[FontWeights["Medium"] = 500] = "Medium";
    FontWeights[FontWeights["SemiBold"] = 600] = "SemiBold";
    FontWeights["Bold"] = "bold";
    FontWeights[FontWeights["ExtraBold"] = 800] = "ExtraBold";
    FontWeights[FontWeights["Black"] = 900] = "Black";
    FontWeights[FontWeights["Heavy"] = 1000] = "Heavy";
})(FontWeights || (FontWeights = {}));
var FontStyles;
(function (FontStyles) {
    FontStyles["Normal"] = "normal";
    FontStyles["Italic"] = "italic";
    FontStyles["Oblique"] = "oblique";
})(FontStyles || (FontStyles = {}));
var FontFormats;
(function (FontFormats) {
    FontFormats["WOFF"] = "woff";
    FontFormats["WOFF2"] = "woff2";
    FontFormats["EOT"] = "embedded-opentype";
    FontFormats["TTF"] = "truetype";
})(FontFormats || (FontFormats = {}));

export { FontFormats, FontStyles, FontWeights };
